import { MarketStatus } from "~/types/event";
import {
  CLOSED_LABEL,
  DISPUTED_LABEL,
  RESOLVED_LABEL,
  RESULT_NOT_AVAILABLE_LABEL,
} from "~/utils/resolution/resolutionLabels";

export const LINES_BY_STATUS: Record<MarketStatus, readonly string[]> = {
  [MarketStatus.ACTIVE]: ["Active"],
  [MarketStatus.CLOSED]: [CLOSED_LABEL],
  [MarketStatus.PROPOSED]: [DISPUTED_LABEL],
  [MarketStatus.DISPUTED]: [DISPUTED_LABEL],
  [MarketStatus.RESOLVED]: [RESOLVED_LABEL, RESULT_NOT_AVAILABLE_LABEL],
};
